import React from 'react';
import { Building2, Stethoscope, BadgeDollarSign, Heart, Clock, Headphones } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const iconMap = {
  Building2,
  Stethoscope,
  BadgeDollarSign,
  Heart,
  Clock,
  HeadphonesIcon: Headphones
};

const WhyChooseUs = () => {
  return (
    <section className="section-padding" style={{ background: 'var(--bg-page)' }}>
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Why Choose India for Medical Tourism?</h2>
          <p className="body-large mx-auto" style={{ maxWidth: '700px', color: 'var(--text-secondary)' }}>
            Combining world-class healthcare with significant cost savings and personalized attention
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyChooseUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div 
                key={item.id} 
                className="voice-card hover-lift"
                style={{ background: 'var(--bg-card)' }}
              >
                <div 
                  className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
                  style={{ background: 'var(--accent-blue-200)' }}
                >
                  <IconComponent size={24} style={{ color: 'var(--text-primary)' }} />
                </div>
                <h3 className="heading-3 mb-2">{item.title}</h3>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;